import { render, staticRenderFns } from "./UploadVersionModal.vue?vue&type=template&id=c5789bea&"
import script from "./UploadVersionModal.vue?vue&type=script&lang=ts&"
export * from "./UploadVersionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports